import compareVersion from '../common/compareVersion';
import getAppVersion from './getAppVersion';

/**
 * 是否支持全屏撑顶
 * @returns {boolean} true 支持 false 不支持
 */
const isSupportFull = () => {
  const supportRes = [0, 1];
  const currentAppVersion = getAppVersion('');
  return supportRes.includes(compareVersion(currentAppVersion || '0.00', '8.15'));
};

export default isSupportFull;
